module.exports = __webpack_public_path__ + "static/media/close-icon-mobile.7644b00b.svg";